import React from 'react';
import MKBHDPrimaryImageSrc from './assets/mkbhd_primary_image.webp';
import MKBHDSecondaryImageSrc from './assets/mkbhd_secondary_image.webp';
import PhilPrimaryImageSrc from './assets/phil_primary_image.webp';
import PhilSecondaryImageSrc from './assets/phil_secondary_image.webp';
import MadsMitchPrimaryImageSrc from './assets/madsmitch_primary_image.webp';
import MadsMitchSecondaryImageSrc from './assets/madsmitch_secondary_image.webp';
import BenAndEmilPrimaryImageSrc from './assets/ben_and_emil_primary_image.webp';
import BenAndEmilSecondaryImageSrc from './assets/ben_and_emil_secondary_image.webp';
import CharlotteDobrePrimaryImageSrc from './assets/charlotte_dobre_primary_image.webp';
import CharlotteDobreSecondaryImageSrc from './assets/charlotte_dobre_secondary_image.webp';
import HarryMackPrimaryImageSrc from './assets/harry_mack_primary_image.webp';
import HarryMackSecondaryImageSrc from './assets/harry_mack_secondary_image.webp';
import JohnnyChangPrimaryImageSrc from './assets/johnny_chang_primary_image.webp';
import JohnnyChangSecondaryImageSrc from './assets/johnny_chang_secondary_image.webp';
import PaoloFromTokyoPrimaryImageSrc from './assets/paolo_primary_image.webp';
import PaoloFromTokyoSecondaryImageSrc from './assets/paolo_secondary_image.webp';
import ArmchairHistorianPrimaryImageSrc from './assets/armchair_primary_image.webp';
import ArmchairHistorianSecondaryImageSrc from './assets/armchair_secondary_image.webp';
import ASMRxBABEEPrimaryImageSrc from './assets/asmrxbabee_primary_image.webp';
import ASMRxBABEESecondaryImageSrc from './assets/asmrxbabee_secondary_image.webp';
const createCreatorData = (name, url, primaryImage, secondaryImage, pronoun = 'his') => ({
    primaryImageSrc: primaryImage,
    secondaryImageSrc: secondaryImage,
    imagesDescription: (React.createElement(React.Fragment, null,
        React.createElement("a", { href: url, target: "_blank", rel: "noreferrer" }, name),
        ' ',
        pronoun === 'their' ? 'power' : 'powers',
        " ",
        pronoun,
        " shop with Fourthwall")),
});
export const creatorsData = {
    MKBHD: createCreatorData('Marques Brownlee', 'https://mkbhd.com/', MKBHDPrimaryImageSrc, MKBHDSecondaryImageSrc),
    'Phil DeFranco': createCreatorData('Phil DeFranco', 'https://beautifulbastard.com/', PhilPrimaryImageSrc, PhilSecondaryImageSrc),
    'Mads Mitch': createCreatorData('Mads Mitch', 'https://madsmitch.com/', MadsMitchPrimaryImageSrc, MadsMitchSecondaryImageSrc, 'her'),
    'Ben & Emil': createCreatorData('Ben & Emil', 'https://benandemilshow.com/', BenAndEmilPrimaryImageSrc, BenAndEmilSecondaryImageSrc, 'their'),
    'Charlotte Dobre': createCreatorData('Charlotte Dobre', 'https://shop.charlottedobre.net/', CharlotteDobrePrimaryImageSrc, CharlotteDobreSecondaryImageSrc, 'her'),
    'Harry Mack': createCreatorData('Harry Mack', 'https://shop.harrymackofficial.com/', HarryMackPrimaryImageSrc, HarryMackSecondaryImageSrc),
    'Johnny Chang': createCreatorData('Johnny Chang', 'https://coreoftheheart.com/', JohnnyChangPrimaryImageSrc, JohnnyChangSecondaryImageSrc, 'her'),
    'Paolo fromTOKYO': createCreatorData('Paolo fromTOKYO', 'https://paolofromtokyoshop.com/', PaoloFromTokyoPrimaryImageSrc, PaoloFromTokyoSecondaryImageSrc),
    'Armchair Historian': createCreatorData('Armchair Historian', 'https://armchairhistory.tv/', ArmchairHistorianPrimaryImageSrc, ArmchairHistorianSecondaryImageSrc, 'their'),
    ASMRxBABEE: createCreatorData('ASMRxBABEE', 'https://asmrxbabee.com/', ASMRxBABEEPrimaryImageSrc, ASMRxBABEESecondaryImageSrc, 'her'),
};
